/**
 * Global list of keys that are used by the caching.
 *
 * Right now it is unused because the caching has only been implemented for the end-user and it
 * cannot be used there.
 */
export enum CacheKeys {}
